import { c as _c } from "react/compiler-runtime";
import { styled, Theme } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';
import { Badge } from '../HorizontalStepper';
type IntroProps = {
  title: string;
  intro: string;
};
type StepIntro = {
  order: number;
  icon?: never;
};
type ServiceIntro = {
  icon: React.ElementType;
  order?: never;
};
type Props = IntroProps & (StepIntro | ServiceIntro);
const ServiceIcon = styled(Box)(({
  theme: {
    palette,
    spacing
  }
}) => ({
  color: palette.brand.primary,
  marginRight: spacing(1),
  width: 18,
  height: 18
}));
const getStepTitleStyle = ({
  theme: {
    palette,
    spacing
  }
}: {
  theme: Theme;
}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: spacing(1),
  borderBottom: `1px solid ${palette.divider}`,
  paddingBottom: spacing(1)
});
const StepTitle = styled('h2')(getStepTitleStyle);
const ServiceTitle = styled('h3')(getStepTitleStyle);
const Intro = t0 => {
  const $ = _c(19);
  const {
    title,
    intro,
    order,
    icon
  } = t0;
  const isStep = order !== undefined;
  const TitleComponent = isStep ? StepTitle : ServiceTitle;
  let t1;
  if ($[0] !== isStep || $[1] !== order) {
    t1 = isStep && <Badge isActive={true}>{order + 1}</Badge>;
    $[0] = isStep;
    $[1] = order;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== icon) {
    t2 = icon && <ServiceIcon component={icon} />;
    $[3] = icon;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = isStep ? "h3" : "h5";
  let t4;
  if ($[5] !== t3 || $[6] !== title) {
    t4 = <Typography variant={t3} component="span">{title}</Typography>;
    $[5] = t3;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== TitleComponent || $[9] !== t1 || $[10] !== t2 || $[11] !== t4) {
    t5 = <TitleComponent>{t1}{t2}{t4}</TitleComponent>;
    $[8] = TitleComponent;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      mb: 6
    };
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== intro) {
    t7 = <Typography variant="body1" component="p" sx={t6}>{intro}</Typography>;
    $[14] = intro;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t7) {
    t8 = <>{t5}{t7}</>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export default Intro;